class UserService {
    constructor($http, initConfigProvider, securityService) {
        this.http = $http;
        this.apiPath = initConfigProvider.apiBaseUrl + initConfigProvider.userServiceEndPoint;
        this.securityService = securityService;
    }

    getCurrentUserId() {
        return this.securityService.getAutheticatedUserId();
    }

    getLineManagers() {
        let curtinId = this.securityService.getAutheticatedUserId();
        return this.http.get(`${this.apiPath}/${curtinId}/lineManagers`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.data && response.data.error) {
                        return {
                            data: null,
                            error: response.data.error
                        };
                    } 
                }
                return {
                    data: null,
                    error: 'User service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'User service error'
                };
            });
    }

    getExecutiveManagers() {
        let curtinId = this.securityService.getAutheticatedUserId();
        return this.http.get(`${this.apiPath}/${curtinId}/executivemanagers`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.data && response.data.error) {
                        return {
                            data: null,
                            error: response.data.error
                        };
                    } 
                }
                return {
                    data: null,
                    error: 'User service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'User service error'
                };
            });
    }

    getPrimaryLineManager() {
        let curtinId = this.securityService.getAutheticatedUserId();
        return this.http.get(`${this.apiPath}/${curtinId}/primarylinemanager`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.data && response.data.error) {
                        return {
                            data: null,
                            error: response.data.error
                        };
                    } 
                }
                return {
                    data: null,
                    error: 'User service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'User service error'
                };
            });
    }

    getMyTasks(filter) {
        let curtinId = this.securityService.getAutheticatedUserId();
        return this.http.get(`${this.apiPath}/${curtinId}/mytasks?pageSize=${filter.pageSize || 20}&pageIndex=${filter.pageIndex || 1}&sortColumn=${filter.sortColumn || ""}
            &sortDirection=${filter.sortDirection || "Descending"}&statusList=${filter.statusList || ""}&download=false`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.data && response.data.error) {
                        return {
                            data: null,
                            error: response.data.error
                        };
                    } 
                }
                return {
                    data: null,
                    error: 'User service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'User service error'
                };
            });
    }
}

UserService.$inject = ['$http', 'initConfigProvider', 'securityService'];

export default UserService;


// WEBPACK FOOTER //
// ./app/services/user.service.js